import styled, { css } from "styled-components";
import HeadingProps from "./Heading.types";

const StyledHeading = styled.div<Pick<HeadingProps, "weight" | "variant" | "color">>`
    ${({ variant }) => {
        if (variant === "h1") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[38]};
            `;
        } else if (variant === "h2") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[32]};
            `;
        } else if (variant === "h3") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[28]};
            `;
        } else if (variant === "h4") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[26]};
            `;
        } else if (variant === "h5") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[24]};
            `;
        } else if (variant === "h6") {
            return css`
                font-size: ${({ theme }) => theme.typography.sizes[22]};
            `;
        } else {
            return null;
        }
    }}
    font-weight: ${(props) => props.theme.typography.weights[props.weight as keyof HeadingProps["weight"]]};
    color: ${(props) => props.theme.colors[props.color as keyof HeadingProps["color"]]};
`;

export default StyledHeading;
